import { makeAutoObservable } from 'mobx'

import { buildArchiveTree, searchArchive } from '../Helpers/diskArchive'

import type { DiskArchiveListing } from '../Contracts/DiskArchive'
import type { DiskArchiveRow } from '../Helpers/diskArchive'

/**
 * Режим «архів» переглядача: перелік ZIP від бека, дерево з нього і пошук за
 * назвою запису. Читає й заповнює його `FileViewerStore`.
 */
export class DiskArchiveStore {
    listing: DiskArchiveListing | null = null
    query = ''

    constructor() {
        makeAutoObservable(this)
    }

    get isSearching(): boolean {
        return this.query.trim() !== ''
    }

    get tree(): DiskArchiveRow[] {
        return this.listing === null ? [] : buildArchiveTree(this.listing.entries)
    }

    get matches(): DiskArchiveRow[] {
        return this.listing === null ? [] : searchArchive(this.listing.entries, this.query)
    }

    /** Рядки таблиці: дерево або, під час пошуку, пласкі збіги з папкою. */
    get rows(): DiskArchiveRow[] {
        return this.isSearching ? this.matches : this.tree
    }

    setListing(listing: DiskArchiveListing): void {
        this.listing = listing
        this.query = ''
    }

    setQuery(query: string): void {
        this.query = query
    }

    reset(): void {
        this.listing = null
        this.query = ''
    }
}
